import { render, staticRenderFns } from "./fisaPacient.vue?vue&type=template&id=05009e72"
import script from "./fisaPacient.vue?vue&type=script&lang=js"
export * from "./fisaPacient.vue?vue&type=script&lang=js"
import style0 from "./fisaPacient.vue?vue&type=style&index=0&id=05009e72&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports